import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static passwordMatch(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('password');
      const repeatPassword = control.get('repeatPassword');

      const passwordsDoNotMatch =
        password && repeatPassword && password.value !== repeatPassword.value;

      return passwordsDoNotMatch ? { passwordsDoNotMatch: true } : null;
    };
  }
}
